import {createApp} from 'vue';
import mapboxgl from "mapbox-gl";

const app = createApp({
    name: "Helper-app",
    data() {
        return {
            currentPos: {
                latitude: null,
                longitude: null,
                accuracy: null
            },
            locationOptions: {
                enableHighAccuracy: true,
                timeout: 10000, // 10 sec on first check
                maximumAge: 0
            },
            locationUpdateOptions: {
                enableHighAccuracy: true,
                timeout: 4000,
                maximumAge: 0
            },
            mapbox: {
                token: 'pk.eyJ1IjoibWlrYWVsYmV2ZW50b3JwIiwiYSI6ImNsZmNlemxvdjAxdWEzdGxyNTBnMGtta3kifQ.n6xahmSCAzoFwiq2lvurJA',
            },
            trackingInterval: 5000, // milliseconds between geolocation pings
            started: false,
            marker: null,
            locationHasBeenSubmitted: false,
            loading: false,
            clickCount: 0,
            end: false,
        }
    },
    computed: {

    },
    methods: {
        start() {
            let app = this;
            navigator.geolocation.getCurrentPosition(app.locationSuccess, app.locationError, app.locationOptions);
            console.log('Location requested..');
        },

        locationSuccess(pos) {
            let app = this;

            this.started = true;
            this.currentPos = pos.coords;

            //this.initMap();

            setInterval(function () {
                navigator.geolocation.getCurrentPosition(app.locationUpdate, app.locationUpdateError, app.locationUpdateOptions);
            }, app.trackingInterval);

        },
        locationError(err) {
            // dont do anything on these errors..
        },

        locationUpdate(pos) {
            this.currentPos = pos.coords;
            /*
            this.marker.setLngLat([pos.coords.longitude, pos.coords.latitude]);

            this.mapbox.map.flyTo({
                center: [pos.coords.longitude, pos.coords.latitude]
            });

             */
            this.locationHasBeenSubmitted = false;
        },
        initMap() {
            let app = this;

            mapboxgl.accessToken = this.mapbox.token;

            let settings = {
                container: 'mapbox-map', // container ID
                style: 'mapbox://styles/mikaelbeventorp/clfcjrcth000m01qick96h1x8', // style URL
                center: [16.5526832, 59.6080444], // starting position [lng, lat]
                zoom: 14, // starting zoom
            };

            this.mapbox.map = new mapboxgl.Map(settings);

            this.mapbox.map.on('load', () => {

                // Add a new Marker.
                app.marker = new mapboxgl.Marker({
                    color: '#F84C4C'
                });
                app.marker.addTo(app.mapbox.map);
            });
        },

        submitPosition() {
            let app = this;

            this.locationHasBeenSubmitted = true;
            this.loading = true;

            jQuery.ajax({
                type: "post",
                dataType: "json",
                url: webien_site_widgets.ajax_url,
                data: {
                    'action': 'map_position_helper',
                    'data': {
                        'pos' : app.currentPos,
                        'postId': window.postId,
                    }
                },
                success: function (response) {
                    app.loading = false;
                    app.clickCount++;

                    if(app.clickCount === 20){
                        app.end = true;
                    }
                }
            })
        },

        // function to check if .test exists in current url
        isTest() {
            return window.location.href.indexOf('.test') > -1;
        }
    },
    mounted() {
        if(this.isTest()){
            this.started = true;
           // this.initMap();
        }
    }
});

// Mount app to DOM
if (document.getElementById("helperMap")) {
    app.mount('#helperMap');
}
